/**
 * Copyright © 2025 Delicious AI, LLC
 * @author Andrew Merrill <andrew.merrill@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { DASHBOARD_INTERVAL_STAT_FRAGMENT } from '@/graphql'

export const GET_INTERVAL_DASHBOARD_STATS = gql`
  query DashboardStatsInterval($filters: DashboardFilter!) {
    intervalDashboardStats(filters: $filters) {
      period
      results {
        ...DashboardIntervalStat
      }
    }
  }
  ${DASHBOARD_INTERVAL_STAT_FRAGMENT}
`
